module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-5JKLVK","includeInDevelopment":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Teaching Center","short_name":"Teaching Center","start_url":"/","background_color":"#271066","theme_color":"#271066","display":"minimal-ui","icon":"src/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"4e4a40baff9dd2d8374a43b4651f5537"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
